import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';
import {
  CorporateLocationDto,
  PagedRequestDto,
  PagedResultDto
} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class CorporateLocationsCorporationService {
  private readonly baseUrl = '/api/corporate-locations/corporation';
  private readonly http = inject(HttpClient);

  get(corporationId: string): Observable<CorporateLocationDto[]> {
    return this.http.get<CorporateLocationDto[]>(
      `${this.baseUrl}/${corporationId}`
    );
  }

  getAllSearch(
    corporationId: string,
    parameters?: PagedRequestDto
  ): Observable<PagedResultDto<CorporateLocationDto>> {
    const params = HttpHelper.toHttpParams(parameters ?? {});
    return this.http.get<PagedResultDto<CorporateLocationDto>>(
      `${this.baseUrl}/${corporationId}/search`,
      { params }
    );
  }

  getAllPrimary(corporationId: string): Observable<CorporateLocationDto> {
    return this.http.get<CorporateLocationDto>(
      `${this.baseUrl}/${corporationId}/primary`
    );
  }
}
